import React from 'react';
import {useSelector} from "react-redux";

export const useIsEditor = () => {
    const pageeditor = useSelector(state => {
        return state.pageEditor
    })

    return (pageeditor.editSectionId !== null && pageeditor.editType === 'section') || (pageeditor.editBlockId !== null && pageeditor.editType === 'block');
}